module.exports = __webpack_public_path__ + "img/service.e86cbea2.jpg";